import React, { useEffect, useState } from 'react';
import { Tag } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Which affiliate (CENTR) products earn clicks, and from which articles. */
export default function AffiliateClicksCard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/admin/affiliate-clicks`)
      .then((r) => r.json())
      .then(setStats)
      .catch(() => {});
  }, []);

  const max = stats?.products?.[0]?.clicks || 1;

  return (
    <div className="bg-zinc-900 border border-zinc-800 p-6" data-testid="affiliate-clicks-card">
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-white text-lg font-semibold flex items-center gap-2" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
          <Tag className="w-4 h-4 text-[#c8ff00]" /> Affiliate Product Clicks (CENTR)
        </h3>
        <div className="text-right">
          <span className="text-[#c8ff00] text-xl font-bold" data-testid="affiliate-clicks-total">{stats?.total ?? 0}</span>
          <span className="text-zinc-500 text-xs ml-2">all time · {stats?.last_30_days ?? 0} last 30d</span>
        </div>
      </div>
      <p className="text-zinc-500 text-xs mb-5">Beacon fires on every tidd.ly / shop.centr.com link click, before redirect.</p>
      {stats?.products?.length > 0 ? (
        <div className="space-y-3">
          {stats.products.map((p) => (
            <div key={p.product} data-testid={`affiliate-product-${p.product}`}>
              <div className="flex items-center justify-between mb-1 gap-3">
                <span className="text-zinc-300 text-sm truncate">{p.product}</span>
                <span className="text-white text-sm font-bold shrink-0">{p.clicks}</span>
              </div>
              <div className="h-2 bg-zinc-800 rounded-full overflow-hidden">
                <div className="h-full bg-[#c8ff00] rounded-full" style={{ width: `${(p.clicks / max) * 100}%` }} />
              </div>
              <p className="text-zinc-600 text-[11px] mt-0.5 truncate">top source: {p.top_article}</p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-zinc-600 text-sm">No affiliate clicks recorded yet — stats appear as soon as readers click a CENTR gear link.</p>
      )}
    </div>
  );
}
